
    <div class="main no-padding"><header-menu></header-menu></div>
    <div class="logo-gif"><img src="assets/shared/img/logo_allya.gif"></div>
  